// Thanks iOS again
// This is needed because iOS has arrow buttons to toggle between inputs
import isMobile from '../util/mobile.js';

export function getAllInputsOnPage() {
    return Array.from(document.getElementsByTagName('input')).concat(Array.from(document.getElementsByTagName('select')));
}

export function disableInputsExcept(currentActiveInput) {
    if (!isMobile()) {
        return null;
    }
    try {
        getAllInputsOnPage()
            .filter(obj => obj.id !== currentActiveInput)
            .forEach(element => {
                element.disabled = true;
            });
    } catch (e) {
        return null;
    }
    return null;
}

export function enableInputs() {
    if (!isMobile()) {
        return null;
    }
    try {
        getAllInputsOnPage().forEach(element => {
            element.disabled = false;
        });
    } catch (e) {
        return null;
    }
    return null;
}
